import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ResourceUnitService} from '../../general-services/service-resources-units-anagraf/resource-unit.service';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import * as toastr from 'toastr';
import {RegionModel} from '../../../models/RegionModel';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {DesignServicesModel} from '../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../models/CurrencyModel';
import {Router} from '@angular/router';
import {ContractualDataModel} from '../../../models/ContractualDataModel';
import {LoaderService} from '../../general-services/service-loader/loader.service';


@Component({
  selector: 'app-resources-units-anagraf',
  templateUrl: './resources-units-anagraf.component.html',
  styleUrls: ['./resources-units-anagraf.component.scss']
})
export class ResourcesUnitsAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy, OnChanges {

  displayedColumns: Array<string>;
  dataSource: any;
  resourceUnitUrl: string;
  isAnagraphSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  filter: ResourcesUnitModel;
  filterAllSettings: AllSettingsFilterModel;
  contractFilter: ContractualDataModel;
  pageSize: number;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() inAllSettings?: boolean;
  @Input() inAllContractMonth?: boolean;
  @Input() idSelected?: number;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() providerForFilterInSettings?: ProviderModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;

  @Input() numAnnoMeseFromForFilterInSettings: number;
  @Input() numAnnoMeseToForFilterInSettings: number;


  @Output() elementSelected = new EventEmitter();

  constructor(private resourceUnitService: ResourceUnitService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.resourceUnitUrl = servers.apiUrl + urls.cobidbService + urls.resourceUnits;
    this.showActions = true;
    this.selectedRowIndex = -1;
    this.filter = new ResourcesUnitModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('regionForFilterInSettings' in changes
      || 'localCustomerForFilterInSettings' in changes
      || 'resourceUnitForFilterInSettings' in changes
      || 'providerForFilterInSettings' in changes
      || 'designServicesForFilterInSettings' in changes
      || 'currencyForFilterInSettings' in changes) {
      this.resetTable();
    }
  }

  ngOnInit() {
    if (this.showActions === true) {
      this.displayedColumns = ['ResourceUnitCod', 'ResourceUnitName', 'Offset', 'inArchStructSett', 'actions'];
    } else {
      this.selectedRowIndex = this.idSelected;
      this.displayedColumns = ['ResourceUnitCod', 'ResourceUnitName', 'Offset'];
    }

    this.pageSize = 10;
    this.setOffsetInSession();
    this.getAll(this.offset);
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.inAllSettings) {
      this.filterAllSettings = new AllSettingsFilterModel(
        this.regionForFilterInSettings, this.localCustomerForFilterInSettings,
        this.filter, this.providerForFilterInSettings,
        this.contractTypeForFilterInSettings);
      this.getPageSubscribe = this.resourceUnitService.getPageInAllSettings(offset, this.filterAllSettings)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else if (this.inAllContractMonth) {
      this.contractFilter = new ContractualDataModel();
      this.contractFilter.numAnnoMeseFrom = this.numAnnoMeseFromForFilterInSettings;
      this.contractFilter.numAnnoMeseTo = this.numAnnoMeseToForFilterInSettings;
      this.contractFilter.region = this.regionForFilterInSettings;
      this.contractFilter.localCustomer = this.localCustomerForFilterInSettings;
      this.contractFilter.contractType = this.contractTypeForFilterInSettings;
      this.contractFilter.provider = this.providerForFilterInSettings;
      this.contractFilter.resourceUnit = this.filter;
      this.getPageSubscribe = this.resourceUnitService.getPageInAllContractMonth(offset, this.contractFilter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else {
      this.getPageSubscribe = this.resourceUnitService.getPage(offset, this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    }
  }

  filterTable() {
    this.getAll(this.offset);
  }

  resetTable() {
    this.filter = new ResourcesUnitModel();
    this.getAll(new Offset(10, 0));
  }

  openDialog(id: number) {
    const resourcesUnitData = this.dataSource.find(data => data.id === id) as ResourcesUnitModel;
    const list: GenericArray[] = [
      { id: 'Resource Cod', value: resourcesUnitData.cod.toString() },
      { id: 'Resource Name', value: resourcesUnitData.name.toString() }
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.resourceUnitService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Resource unit with id ' + id + ' was deleted with success', 'Success');

              this.getAll(this.offset);
            } else {
              toastr.info('Resource unit cannot be deleted', 'Alert');
            }

          }, error =>  {
            toastr.error('Resource unit with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    console.log(dataFiltered);
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('resourceUnitOffset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('resourceUnitOffset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(10, 0);
      this.pageSize = this.offset.pageSize;
    }
  }
}
